// extracted by mini-css-extract-plugin
export default {"heading":"home_heading__gNhgl"};